module.exports = __webpack_public_path__ + "static/media/error.2b828523.svg";